module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("jTIGJ"))).then(() => parcelRequire('hEqeo'));